import useCheggHeaderSession, {
  CheggHeaderSession,
} from '@chegg-wt/core/hooks/useCheggHeaderSession'
import React, { createContext, useContext } from 'react'

const CheggLayoutContext = createContext<CheggHeaderSession>({
  serverRenderAsMobile: true,
  user: null,
  csrfToken: null,
  pageTrackId: null,
  error: false,
  completed: false,
})

export const useCheggLayout = () => useContext(CheggLayoutContext)

export const CheggLayoutProvider = ({ userAgent, skip, children }) => {
  const cheggHeaderSession = useCheggHeaderSession({ userAgent, skip })

  return (
    <CheggLayoutContext.Provider value={cheggHeaderSession}>
      {children}
    </CheggLayoutContext.Provider>
  )
}
